<script>
	import Leader from '$lib/icons/leadership-svgrepo-com.svelte';
	import Group from '$lib/icons/group-svgrepo-com.svelte';
	import Collaboration from '$lib/icons/collaboration-picture-visualize-person-svgrepo-com.svelte';
</script>

<div class="content-div">
	<span class="chip static-courser bg-[#6B9B2A] mt-4 text-white"><b>WP 5</b></span>
	<div class="flex">
		<h1 class="content-heading">
			Stakeholder engagements (continuous participatory co-production)
		</h1>
		<Collaboration />
	</div>

	<blockquote class="content-blockquote">
		This WP will ensure that the project is co-produced with stakeholders and that the project
		activities are aligned with the needs of the stakeholders.
	</blockquote>

	<div class="flex pt-10">
		<Leader />
		<div class="pl-4 text-lg">
			<a class="anchor" href="/team/#coleen_vogel">Coleen Vogel (WITS)</a>
		</div>
	</div>

	<div class="flex pt-4">
		<Group />
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#wits_gci">WITS-GCI</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#unza_iwemc">UNZA-IWRMC</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#uni_jena">Uni Jena</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#gobabeb">Gobabeb</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#ub">UB</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#gerics">GERICS</a></div>
	</div>

	<h2 class="h4 pt-10 pb-2">Objectives</h2>
	The southern African region is one of the most vulnerable to climate stress and climate change. The
	awareness of changing climate is growing but immediate and extensive climate change actions are needed.
	Before one can act effectively and avoid maladaptation one needs to ensure the relevant context and
	‘sense making’ of all the actors involved (all knowledge holders including researchers and co-engaged
	actors are needed to design the effective governance of adaptation actions going forward). Increasingly
	the need to work across science-policy-practice action areas, including the SDGs, Sendai Framework
	and Paris Climate Change Agreement is being promoted to stimulate change with the key intersection
	being ‘adaptation to climate risks’. A key element for southern Africa will thus be trying to work
	from a system’s perspective in understanding how the region’s projected risks manifest in the local,
	national and a regional policy and governance context. In trying to enhance one’s understanding of
	a system will require first comprehending how the system is being framed, understood and constructed.
	Framing of an issue can influence how one adapts or intervenes into a situation (Leach et al., 2010).
	One of the first key efforts in the adaptation design of the project will therefore be to get a better
	sense of the intersections between the research team and other actors. It is particularly important
	that those operating in the policy-practice arena understand the risk environment and potential ‘adaptation’
	environment in which we all live. The need therefore to acknowledge that adaptation cannot be divorced
	from context including the socio-political and power differentials in a system are therefore critical
	to understand and help frame before one can actually decide on adaptation processes. Notions of incremental
	adaptation changes are therefore as important to understand as the much needed ‘future and more radical
	and system’s innovative changes) that may be required usually referred to as transformative adaptation
	(O’Brien, 2015). These aspects will be co-developed in the project and will inform the content of WPs
	2 and 4, towards the generation of climate services (WP3) and the formulation of adaptation options.
	This will be achieved through annual co-production meetings with the team and stakeholders from across
	SADC, and targeted and continuous stakeholder engagements in each of the case-study regions (see Table
	2). Through this work we thus intend to better understand together (the research team and the actors
	engaged) how we can better cope with some of the key tipping points at the regional but also at the
	very local scale in a changing climate and socio-economic context.
</div>
